import { render, staticRenderFns } from "./DeviceTableSimplified.vue?vue&type=template&id=aa4b66d4&"
import script from "./DeviceTableSimplified.vue?vue&type=script&lang=js&"
export * from "./DeviceTableSimplified.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports